import { render, staticRenderFns } from "./ReleaseOverview.vue?vue&type=template&id=05d82c4f&scoped=true&"
import script from "./ReleaseOverview.vue?vue&type=script&lang=js&"
export * from "./ReleaseOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseOverview.vue?vue&type=style&index=0&id=05d82c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d82c4f",
  null
  
)

export default component.exports